/**
 * Do not edit directly
 * Generated on Thu, 10 Sep 2026 09:09:17 GMT
 */

export const ColorWhite = "#ffffff";
export const ColorGrayLightest = "#FAF9F8";
export const ColorGrayLighter = "#F6F4F2";
export const ColorGrayLight = "#D9D6D4";
export const ColorGray = "#A5A3A2";
export const ColorGrayDark = "#484746";
export const ColorGrayDarker = "#484746";
export const ColorGrayDarkest = "#484746";
export const ColorBlack = "#000000";
export const ColorBlueLightest = "#BCD4FA";
export const ColorBlueLighter = "#79A9F4";
export const ColorBlueLight = "#4D8CF1";
export const ColorBlue = "#206FED";
export const ColorBlueDark = "#13438E";
export const ColorBlueDarker = "#0D2C5F";
export const ColorBlueDarkest = "#06162F";
export const ColorTealLightest = "#D2F9F9";
export const ColorTealLighter = "#8FEFEF";
export const ColorTealLight = "#42D7D7";
export const ColorTeal = "#24A8A8";
export const ColorTealDark = "#228787";
export const ColorTealDarker = "#175A5A";
export const ColorTealDarkest = "#033535";
export const ColorGreenLightest = "#CEEEE0";
export const ColorGreenLighter = "#9DDDC1";
export const ColorGreenLight = "#6CCBA2";
export const ColorGreen = "#3BBA83";
export const ColorGreenDark = "#0AA964";
export const ColorGreenDarker = "#06653C";
export const ColorGreenDarkest = "#044428";
export const ColorYellowLightest = "#FFF8E5";
export const ColorYellowLighter = "#FFE499";
export const ColorYellowLight = "#FFD666";
export const ColorYellow = "#FFC21C";
export const ColorYellowDark = "#B2801A";
export const ColorYellowDarker = "#866013";
export const ColorYellowDarkest = "#3D2E0F";
export const ColorRedLightest = "#FEC4CD";
export const ColorRedLighter = "#FE9DAC";
export const ColorRedLight = "#FD6279";
export const ColorRed = "#FC3B58";
export const ColorRedDark = "#CA2F46";
export const ColorRedDarker = "#972335";
export const ColorRedDarkest = "#4C121A";
export const ColorOrangeLightest = "#fce2cc";
export const ColorOrangeLighter = "#fbd3b3";
export const ColorOrangeLight = "#f6a766";
export const ColorOrange = "#f38933";
export const ColorOrangeDark = "#C05600";
export const ColorOrangeDarker = "#904100";
export const ColorOrangeDarkest = "#301600";
export const ColorPurpleLightest = "#F0EDFF";
export const ColorPurpleLighter = "#D4CCFF";
export const ColorPurpleLight = "#9B89F5";
export const ColorPurple = "#765EED";
export const ColorPurpleDark = "#5B42D7";
export const ColorPurpleDarker = "#36248F";
export const ColorPurpleDarkest = "#170F3E";
export const ColorPinkLightest = "#FFE5F2";
export const ColorPinkLighter = "#FDB4D9";
export const ColorPinkLight = "#F986BF";
export const ColorPink = "#ED5EA6";
export const ColorPinkDark = "#E51A80";
export const ColorPinkDarker = "#B81466";
export const ColorPinkDarkest = "#4F1733";
export const ColorChart1 = "#1A59BE";
export const ColorChart2 = "#175A5A";
export const ColorChart3 = "#F06C00";
export const ColorChart4 = "#765EED";
export const ColorChart5 = "#E51A80";
export const ColorChart6 = "#0D2C5F";
export const ColorChart7 = "#228787";
export const ColorChart8 = "#866013";
export const ColorHeatWarm1 = "#3EC67B";
export const ColorHeatWarm2 = "#42D688";
export const ColorHeatWarm3 = "#68D985";
export const ColorHeatWarm4 = "#8EDC82";
export const ColorHeatWarm5 = "#B3DF80";
export const ColorHeatWarm6 = "#D9E27D";
export const ColorHeatWarm7 = "#FFE57A";
export const ColorHeatWarm8 = "#FFC76D";
export const ColorHeatWarm9 = "#FFAA61";
export const ColorHeatWarm10 = "#FF8C54";
export const ColorHeatWarm11 = "#FF6D5B";
export const ColorHeatWarm12 = "#FC3B58";
export const ColorHeatCool1 = "#E9F1FD";
export const ColorHeatCool2 = "#D2E2FB";
export const ColorHeatCool3 = "#BCD4FA";
export const ColorHeatCool4 = "#79A9F4";
export const ColorHeatCool5 = "#4D8CF1";
export const ColorHeatCool6 = "#206FED";
export const ColorHeatCool7 = "#1A59BE";
export const ColorHeatCool8 = "#13438E";
export const ColorHeatCool9 = "#0D2C5F";
export const ColorHeatCool10 = "#06162F";
export const ColorScaleCool1 = "#4D8CF1";
export const ColorScaleCool2 = "#206FED";
export const ColorScaleCool3 = "#13438E";
export const ColorScaleCool4 = "#0D2C5F";
export const ColorScaleWarm1 = "#0AA964";
export const ColorScaleWarm2 = "#FFC21C";
export const ColorScaleWarm3 = "#F06C00";
export const ColorScaleWarm4 = "#FC3B58";
export const ColorStatusPositiveDarker = "#06653C";
export const ColorStatusPositiveDark = "#0AA964";
export const ColorStatusPositive = "#3BBA83";
export const ColorStatusPositiveLight = "#6CCBA2";
export const ColorStatusPositiveLighter = "#9DDDC1";
export const ColorStatusPositiveLightest = "#CEEEE0";
export const ColorStatusPositiveLightForeground = "#044428";
export const ColorStatusWarningBackground = "#FFF8E5";
export const ColorStatusWarningHighlightLighter = "#FFE499";
export const ColorStatusWarningHighlightLight = "#FFD666";
export const ColorStatusWarningHighlight = "#FFC21C";
export const ColorStatusWarningLightest = "#FFF8E5";
export const ColorStatusWarningLighter = "#FFE499";
export const ColorStatusWarningLight = "#FFF8E5";
export const ColorStatusWarning = "#FFC21C";
export const ColorStatusWarningDark = "#866013";
export const ColorStatusWarningDarkForeground = "#FFFFFF";
export const ColorStatusWarningNeutral = "#FFC21C";
export const ColorStatusWarningLightForeground = "#3D2E0F";
export const ColorStatusNegativeDarker = "#972335";
export const ColorStatusNegativeDark = "#CA2F46";
export const ColorStatusNegativeLightest = "#FEC4CD";
export const ColorStatusNegativeLighter = "#FE9DAC";
export const ColorStatusNegativeLight = "#FFEBEE";
export const ColorStatusNegative = "#FC3B58";
export const ColorStatusNegativeLightForeground = "#CA2F46";
export const ColorStatusSubtleDark = "#484746";
export const ColorStatusSubtleLight = "#F6F4F2";
export const ColorStatusSubtleLightForeground = "#000000";
export const ColorStatusNeutralDark = "#13438E";
export const ColorStatusNeutralLight = "#E9F1FD";
export const ColorStatusNeutralLightForeground = "#13438E";
export const ColorStatusHighlight1Dark = "#175A5A";
export const ColorStatusHighlight1Light = "#D2F9F9";
export const ColorStatusHighlight1LightForeground = "#033535";
export const ColorStatusHighlight2Dark = "#E51A80";
export const ColorStatusHighlight2Light = "#FFE5F2";
export const ColorStatusHighlight3Dark = "#765EED";
export const ColorStatusHighlight3Light = "#F0EDFF";
export const ColorStatusHighlight3LightForeground = "#5B42D7";
export const ColorBorderSeparator = "#D9D6D4";
export const ColorBorderInteractiveDefault = "#484746";
export const ColorBorderInteractiveError = "#CA2F46";
export const ColorBorderInteractiveHover = "#9E007E";
export const ColorBorderInteractiveActive = "#9E007E";
export const ColorBorderInteractiveActiveChecked = "#7E0065";
export const ColorBorderInteractiveSelected = "#9E007E";
export const ColorBorderInteractiveDisabled = "#D9D6D4";
export const ColorBackgroundMainPage = "#FAF9F8";
export const ColorBackgroundInteractiveDefault = "#FFFFFF";
export const ColorBackgroundInteractiveHover = "#F7F5F4";
export const ColorBackgroundInteractiveActive = "#F5E6F2";
export const ColorBackgroundInteractiveActiveChecked = "#6F0058";
export const ColorBackgroundInteractiveSelected = "#F5E6F2";
export const ColorBackgroundInteractiveDisabled = "#F0ECE9";
export const ColorBackgroundStaticPrimary = "#FFFFFF";
export const ColorBackgroundStaticSecondary = "#F7F5F4";
export const ColorToastBackgroundWarning = "#FFC21C";
export const ColorToastColorWarning = "#3D2E0F";
export const ColorToastForegroundWarning = "#3D2E0F";
export const ColorButtonDisabledForeground = "#484746";
export const ColorButtonDefaultForeground = "#000000";
export const ColorButtonDefaultBackground = "#FFFFFF";
export const ColorButtonDefaultBorder = "#484746";
export const ColorButtonDefaultHoverBorder = "#484746";
export const ColorButtonDefaultHoverShadow = "0 0 0 0.1875rem #F0ECE9";
export const ColorButtonDefaultFocusShadow = "0 0 0 0.125rem #FFFFFF, 0 0 0 0.25rem #484746";
export const ColorButtonDefaultActiveBackground = "#FAF9F8";
export const ColorButtonDefaultActiveBorder = "#484746";
export const ColorButtonDefaultActiveForeground = "#000000";
export const ColorButtonPrimaryForeground = "#FFFFFF";
export const ColorButtonPrimaryBackground = "#9E007E";
export const ColorButtonPrimaryBorder = "#9E007E";
export const ColorButtonPrimaryHoverBorder = "#9E007E";
export const ColorButtonPrimaryHoverShadow = "0 0 0 0.1875rem color-mix(in srgb, #9E007E calc(0.2 * 100%), transparent)";
export const ColorButtonPrimaryFocusShadow = "0 0 0 0.125rem #ffffff, 0 0 0 0.25rem #9E007E";
export const ColorButtonPrimaryActiveBackground = "#7E0065";
export const ColorButtonPrimaryActiveBorder = "#7E0065";
export const ColorButtonPrimaryActiveForeground = "#FFFFFF";
export const ColorButtonSecondaryForeground = "#9E007E";
export const ColorButtonSecondaryBackground = "#FFFFFF";
export const ColorButtonSecondaryBorder = "#9E007E";
export const ColorButtonSecondaryHoverBorder = "#9E007E";
export const ColorButtonSecondaryHoverShadow = "0 0 0 0.1875rem color-mix(in srgb, #9E007E calc(0.2 * 100%), transparent)";
export const ColorButtonSecondaryFocusShadow = "0 0 0 0.125rem #ffffff, 0 0 0 0.25rem #9E007E";
export const ColorButtonSecondaryActiveBackground = "#7E0065";
export const ColorButtonSecondaryActiveBorder = "#7E0065";
export const ColorButtonSecondaryActiveForeground = "#FFFFFF";
export const ColorButtonDestructiveForeground = "#FFFFFF";
export const ColorButtonDestructiveBackground = "#CA2F46";
export const ColorButtonDestructiveBorder = "#CA2F46";
export const ColorButtonDestructiveHoverBorder = "#972335";
export const ColorButtonDestructiveHoverShadow = "0 0 0 0.1875rem color-mix(in srgb, #D04257 20%, transparent)";
export const ColorButtonDestructiveFocusShadow = "0 0 0 0.125rem #FFFFFF, 0 0 0 0.25rem #CA2F46";
export const ColorButtonDestructiveActiveBackground = "#972335";
export const ColorButtonDestructiveActiveBorder = "#972335";
export const ColorButtonDestructiveActiveForeground = "#ffffff";
export const ColorButtonBorderlessForeground = "#000000";
export const ColorButtonBorderlessBackground = "transparent";
export const ColorButtonBorderlessBorder = "transparent";
export const ColorButtonBorderlessHoverBorder = "#484746";
export const ColorButtonBorderlessHoverShadow = "0 0 0 0.1875rem #F0ECE9";
export const ColorButtonBorderlessFocusShadow = "0 0 0 0.125rem #FFFFFF, 0 0 0 0.25rem #484746";
export const ColorButtonBorderlessActiveBackground = "transparent";
export const ColorButtonBorderlessActiveBorder = "#484746";
export const ColorButtonBorderlessActiveForeground = "#000000";
export const ColorButtonCtaDefaultForeground = "#000000";
export const ColorButtonCtaDefaultBackground = "#FFFFFF";
export const ColorButtonCtaDefaultBorder = "#484746";
export const ColorButtonCtaDefaultHoverBorder = "#484746";
export const ColorButtonCtaDefaultHoverShadow = "0 0 0 0.1875rem #F0ECE9";
export const ColorButtonCtaDefaultFocusShadow = "0 0 0 0.125rem #FFFFFF, 0 0 0 0.25rem #484746";
export const ColorButtonCtaDefaultActiveBackground = "#FAF9F8";
export const ColorButtonCtaDefaultActiveBorder = "#484746";
export const ColorButtonCtaDefaultActiveForeground = "#000000";
export const ColorButtonCtaPrimaryForeground = "#FFFFFF";
export const ColorButtonCtaPrimaryBackground = "#9E007E";
export const ColorButtonCtaPrimaryBorder = "#9E007E";
export const ColorButtonCtaPrimaryHoverBorder = "#9E007E";
export const ColorButtonCtaPrimaryHoverShadow = "0 0 0 0.1875rem color-mix(in srgb, #9E007E calc(0.2 * 100%), transparent)";
export const ColorButtonCtaPrimaryFocusShadow = "0 0 0 0.125rem #ffffff, 0 0 0 0.25rem #9E007E";
export const ColorButtonCtaPrimaryActiveBackground = "#7E0065";
export const ColorButtonCtaPrimaryActiveBorder = "#7E0065";
export const ColorButtonCtaPrimaryActiveForeground = "#FFFFFF";
export const ColorButtonCtaSecondaryForeground = "#9E007E";
export const ColorButtonCtaSecondaryBackground = "#FFFFFF";
export const ColorButtonCtaSecondaryBorder = "#9E007E";
export const ColorButtonCtaSecondaryHoverBorder = "#9E007E";
export const ColorButtonCtaSecondaryHoverShadow = "0 0 0 0.1875rem color-mix(in srgb, #9E007E calc(0.2 * 100%), transparent)";
export const ColorButtonCtaSecondaryFocusShadow = "0 0 0 0.125rem #ffffff, 0 0 0 0.25rem #9E007E";
export const ColorButtonCtaSecondaryActiveBackground = "#7E0065";
export const ColorButtonCtaSecondaryActiveBorder = "#7E0065";
export const ColorButtonCtaSecondaryActiveForeground = "#FFFFFF";
export const ColorButtonCtaSecondaryNotActive = "#FFFFFF";
export const ColorButtonCtaSecondaryActive = "#7E0065";
export const ColorButtonSecondaryNotActive = "#FFFFFF";
export const ColorButtonSecondaryNotActiveHoverBorder = "#9E007E";
export const ColorButtonSecondaryActive = "#7E0065";
export const ColorLinkForeground = "#1A59BE";
export const ColorLinkHoverForeground = "#13438E";
export const ColorLinkActiveForeground = "#0D2C5F";
export const ColorLinkVisitedForeground = "#4128BD";
export const ColorTypographyToneSubtle = "#484746";
export const ColorTypographyTonePositive = "#06653C";
export const ColorTypographyToneNegative = "#CA2F46";
export const ColorTypographyToneWarning = "#866013";
export const ColorTextInteractiveDarkDefault = "#000000";
export const ColorTextInteractiveLightDefault = "#FFFFFF";
export const ColorTextInteractiveDisabled = "#484746";
export const ColorTextStaticHeader = "#000000";
export const ColorTextStaticBody = "#000000";
export const ColorTextHighlightLightForeground = "#000000";
export const ColorTextHighlightLightBackground = "color-mix(in srgb, #9E007E 40%, transparent)";
export const ColorTextHighlightDarkForeground = "#CF80BF";
export const ColorTextHighlightDarkBackground = "transparent";
export const ColorNavigationTopBackground = "#FFFFFF";
export const ColorNavigationBackground = "#FFFFFF";
export const ColorNavigationForeground = "#000000";
export const ColorNavigationHover = "#F6F4F2";
export const ColorNavigationFocus = "#9E007E";
export const ColorNavigationActive = "#F6F4F2";
export const ColorNavigationActiveForeground = "#9E007E";
export const ColorNavigationActiveBorder = "#9E007E";
export const ColorNavigationDivider = "#D9D6D4";
export const ColorNavigationBorder = "0.094rem solid #D9D6D4";
export const ColorSearchNavigationTextDefault = "#000000";
export const ColorSearchNavigationTextSecondary = "#757372";
export const ColorSearchNavigationBackgroundDefault = "#FFFFFF";
export const ColorSearchNavigationBackgroundHover = "#FFFFFF";
export const ColorSearchNavigationShadowHover = "0 0 0 0.1875rem color-mix(in srgb, #9E007E calc(0.2 * 100%), transparent)";
export const ColorSearchNavigationHoverOutline = "#9E007E";
export const ColorSearchNavigationFocusOutline = "#9E007E";
export const ColorSearchNavigationActiveOutline = "#F7F5F4";
export const ColorSearchNavigationResultsSectionBorder = "#F6F4F2";
export const ColorSearchNavigationResultsItemHover = "#F7F5F4";
export const ColorSearchNavigationResultsItemActive = "#F7F5F4";
export const ColorGray100 = "#FFFFFF";
export const ColorGray200 = "#FAF9F8";
export const ColorGray300 = "#F7F5F4";
export const ColorGray400 = "#F6F4F2";
export const ColorGray500 = "#F0ECE9";
export const ColorGray600 = "#D9D6D4";
export const ColorGray700 = "#A5A3A2";
export const ColorGray800 = "#757372";
export const ColorGray900 = "#484746";
export const ColorGray1000 = "#000000";
export const ColorBlue100 = "#E9F1FD";
export const ColorBlue200 = "#D2E2FB";
export const ColorBlue300 = "#BCD4FA";
export const ColorBlue400 = "#79A9F4";
export const ColorBlue500 = "#4D8CF1";
export const ColorBlue600 = "#206FED";
export const ColorBlue700 = "#1A59BE";
export const ColorBlue800 = "#13438E";
export const ColorBlue900 = "#0D2C5F";
export const ColorBlue1000 = "#06162F";
export const ColorTeal100 = "#E6FCFC";
export const ColorTeal200 = "#D2F9F9";
export const ColorTeal300 = "#BCF5F5";
export const ColorTeal400 = "#8FEFEF";
export const ColorTeal500 = "#63E9E9";
export const ColorTeal600 = "#42D7D7";
export const ColorTeal700 = "#24A8A8";
export const ColorTeal800 = "#228787";
export const ColorTeal900 = "#175A5A";
export const ColorTeal1000 = "#033535";
export const ColorGreen100 = "#E7F6F0";
export const ColorGreen200 = "#CEEEE0";
export const ColorGreen300 = "#9DDDC1";
export const ColorGreen400 = "#6CCBA2";
export const ColorGreen500 = "#3BBA83";
export const ColorGreen600 = "#0AA964";
export const ColorGreen700 = "#088750";
export const ColorGreen800 = "#06653C";
export const ColorGreen900 = "#044428";
export const ColorGreen1000 = "#03331E";
export const ColorYellow100 = "#FFF8E5";
export const ColorYellow200 = "#FFEFC2";
export const ColorYellow300 = "#FFE499";
export const ColorYellow400 = "#FFD666";
export const ColorYellow500 = "#FFC21C";
export const ColorYellow600 = "#B2801A";
export const ColorYellow700 = "#866013";
export const ColorYellow800 = "#523D14";
export const ColorYellow900 = "#3D2E0F";
export const ColorYellow1000 = "#291F0A";
export const ColorRed100 = "#FFEBEE";
export const ColorRed200 = "#FED8DE";
export const ColorRed300 = "#FEC4CD";
export const ColorRed400 = "#FE9DAC";
export const ColorRed500 = "#FD6279";
export const ColorRed600 = "#FC3B58";
export const ColorRed700 = "#CA2F46";
export const ColorRed800 = "#972335";
export const ColorRed900 = "#651823";
export const ColorRed1000 = "#4C121A";
export const ColorPink100 = "#FFE5F2";
export const ColorPink200 = "#FDB4D9";
export const ColorPink300 = "#F986BF";
export const ColorPink400 = "#ED5EA6";
export const ColorPink500 = "#E51A80";
export const ColorPink600 = "#B81466";
export const ColorPink700 = "#86134D";
export const ColorPink800 = "#691640";
export const ColorPink900 = "#4F1733";
export const ColorPink1000 = "#391326";
export const ColorOrange100 = "#FEF0E6";
export const ColorOrange200 = "#fce2cc";
export const ColorOrange300 = "#fbd3b3";
export const ColorOrange400 = "#f6a766";
export const ColorOrange500 = "#f38933";
export const ColorOrange600 = "#F06C00";
export const ColorOrange700 = "#C05600";
export const ColorOrange800 = "#904100";
export const ColorOrange900 = "#602B00";
export const ColorOrange1000 = "#301600";
export const ColorPurple100 = "#F0EDFF";
export const ColorPurple200 = "#D4CCFF";
export const ColorPurple300 = "#C1B4FD";
export const ColorPurple400 = "#9B89F5";
export const ColorPurple500 = "#765EED";
export const ColorPurple600 = "#5B42D7";
export const ColorPurple700 = "#4128BD";
export const ColorPurple800 = "#36248F";
export const ColorPurple900 = "#261A66";
export const ColorPurple1000 = "#170F3E";
export const ColorPlum100 = "#F5E6F2";
export const ColorPlum200 = "#E2B3D8";
export const ColorPlum300 = "#CF80BF";
export const ColorPlum400 = "#BB4DA5";
export const ColorPlum500 = "#A81A8B";
export const ColorPlum600 = "#9E007E";
export const ColorPlum700 = "#8E0071";
export const ColorPlum800 = "#7E0065";
export const ColorPlum900 = "#6F0058";
export const ColorPlum1000 = "#4F003F";
export const ColorBackgroundStaticTertiary = "#F6F4F2";
export const ColorBackgroundDestructive = "#CA2F46";
export const ColorCardBorder = "0.0625rem solid #D9D6D4";
export const ColorStatusBrandDark = "#9E007E";
export const ColorStatusBrandLight = "#F5E6F2";
export const FontFamilyDefault = "'IBM Plex Sans', arial, sans-serif";
export const FontFamilyAlternative = "'IBM Plex Sans', arial, sans-serif";
export const FontFamilyCode = "'IBM Plex Mono', courier, sans-serif";
export const FontFamilyHeading = "'IBM Plex Sans', arial, sans-serif";
export const FontFamilyDisplay = "'IBM Plex Sans', arial, sans-serif";
export const FontSizeXxSmall = "0.625rem";
export const FontSizeXSmall = "0.75rem";
export const FontSizeSmall = "0.875rem"; // body
export const FontSizeMedium = "1rem";
export const FontSizeLarge = "1.125rem";
export const FontSizeXLarge = "1.375rem";
export const FontSizeXxLarge = "1.6875rem";
export const FontSizeXxxLarge = "2rem";
export const FontSizeInteractiveDefault = "0.875rem";
export const FontWeightNormal = 400;
export const FontWeightMedium = 500;
export const FontWeightBold = 700;
export const FontWeightInteractiveDefault = 400;
export const FontWeightInteractiveSelected = 500;
export const LineHeightReset = "1";
export const LineHeightXSmall = "1.1"; // title/url cell
export const LineHeightSmall = "1.3"; // text
export const LineHeightMedium = "1.4";
export const LineHeightLarge = "1.5";
export const LineHeightXLarge = "1.6";
export const SizeButtonSmall = "1.375rem";
export const SizeButtonDefault = "2rem";
export const SizeButtonLarge = "2.5rem";
export const SizeIconSmall = "0.75rem";
export const SizeIconMedium = "1rem";
export const SizeIconDefault = "1.25rem";
export const SizeIconResponsive = "1.25em";
export const SizeIllustrationSmall = "6rem";
export const SizeIllustrationMedium = "8rem";
export const SizeIllustrationDefault = "12rem";
export const SizePillSmall = "1.25rem";
export const SizePillDefault = "1.375rem";
export const SizePillLarge = "1.5rem";
export const SizeShadowFocusInner = "0 0 0 0.125rem";
export const SizeShadowFocusOuter = "0 0 0 0.25rem";
export const SizeShadowHover = "0 0 0 0.1875rem";
export const SpaceXxSmall = "0.25rem";
export const SpaceXSmall = "0.5rem";
export const SpaceSmall = "0.75rem";
export const SpaceMedium = "1rem";
export const SpaceLarge = "1.25rem";
export const SpaceXLarge = "1.5rem";
export const SpaceXxLarge = "2rem";
export const SpaceXxxLarge = "2.5rem";
export const BorderRadiusSmall = "0.1875rem";
export const BorderRadiusMedium = "0.3125rem";
export const BorderRadiusRounded = "125rem";
export const OpacityShadowHover = "0.2";
export const BorderCard = "0.0625rem solid #D9D6D4";
export const ShadowLayerLow = "0 0.0625rem 0.125rem 0 color-mix(in srgb, #A5A3A2 20%, transparent)"; // rgba value equals color.gray--700 with 0.0/0.2 opacity
export const ShadowLayerMedium = "0 0.25rem 0.5rem 0 color-mix(in srgb, #A5A3A2 12%, transparent), 0 0.125rem 0.25rem 0 color-mix(in srgb, #A5A3A2 8%, transparent)"; // rgba value equals color.gray--700 with 0.12/0.08 opacity
export const ShadowLayerHigh = "0 0.5rem 0.75rem 0 color-mix(in srgb, #A5A3A2 16%, transparent), 0 0.25rem 0.375rem 0 color-mix(in srgb, #A5A3A2 4%, transparent)"; // rgba value equals color.gray--700 with 0.16/0.04 opacity
export const ShadowFocusBase = "0 0 0 0.125rem #ffffff";
export const ShadowFocusDefault = "0 0 0 0.125rem #ffffff, 0 0 0 0.25rem #9E007E";
export const ShadowFocusInner = "inset 0 0 0 0.125rem #9E007E";
export const ShadowFocusInnerNeutral = "inset 0 0 0 0.125rem #484746";
export const ShadowHoverDefault = "0 0 0 0.1875rem color-mix(in srgb, #9E007E calc(0.2 * 100%), transparent)"; // rgba value equals color.teal with opacity.shadow--hover
export const ShadowHoverError = "0 0 0 0.1875rem color-mix(in srgb, #FD6279 calc(0.2 * 100%), transparent)"; // rgba value equals color.red with opacity.shadow--hover
export const ShadowHoverLeft = "inset 0.1875rem 0 0 0 #D9D6D4";
export const ShadowHoverBottom = "inset 0 -0.125rem 0 rgba(60, 72, 94, 0.15)"; // rgba value equals color.gray--lighter with 0.15 opacity
export const ShadowSelected = "inset 0.1875rem 0 #9E007E, inset 0 0.0625rem #9E007E, inset -0.0625rem 0 #9E007E, inset 0 -0.0625rem #9E007E";
export const ShadowSelectedBottom = "inset 0 -0.1875rem 0 0 #9E007E";
export const ShadowSelectedLeft = "inset 0.1875rem 0 #9E007E";
export const LayoutSmall = "36rem";
export const LayoutMedium = "48rem";
export const LayoutLarge = "62rem";
export const LayoutXLarge = "75rem";
export const LayoutXxLarge = "100rem";
export const AnimationFast = "0.1s";
export const AnimationMedium = "0.2s";
export const AnimationSlow = "0.3s";
export const VariantSearchNavigationResultsItemHighlight = "light";
export const VariantNavigationSpinner = "dark";
